'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SuccessAlert = function SuccessAlert() {
  return React__default["default"].createElement("svg", {
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    transform: "translate(5.000000, 17.000000)"
  }, React__default["default"].createElement("g", {
    fill: "#00C853",
    fillOpacity: "0.04"
  }, React__default["default"].createElement("path", {
    d: "M168,201 C168,204.313333 143.152033,207 112.5,207 C81.8479667,207 57,204.313333 57,201 C57,197.686667 81.8479667,195 112.5,195 C143.152033,195 168,197.686667 168,201",
    id: "Fill-1"
  }), React__default["default"].createElement("path", {
    d: "M127.47539,31.3197618 C109.013533,18.7025186 89.8996737,5.80108645 67.9881499,1.36947677 C46.0753866,-3.06213291 20.4253803,3.12300925 8.34224775,21.9514556 C0.350869474,34.3999229 -0.523013213,50.0663022 0.205842135,64.8466078 C0.602498106,72.8907674 1.4292779,81.034207 4.34222019,88.5410138 C16.6249203,120.197673 59.6620932,128.967818 76.420808,158.493681 C79.9051828,164.629183 82.1896733,171.588709 87.0140015,176.733893 C97.8501468,188.286359 116.930539,186.23871 131.33039,179.65893 C145.731481,173.07915 158.807493,162.839662 174.404749,160.134282 C192.680673,156.964769 215.784644,163.020848 226.770775,148.058115 C234.63448,137.348288 230.42001,121.940037 223.182278,110.79586 C211.597444,92.9577315 193.741728,80.3218732 176.323573,68.1315339 C156.547793,54.290665 144.477056,43.2358403 124.701277,29.3937304",
    id: "Fill-3"
  })), React__default["default"].createElement("circle", {
    strokeOpacity: "0.87",
    stroke: "#000000",
    strokeWidth: "3",
    fill: "#FFFFFF",
    cx: "111",
    cy: "91.5",
    r: "63.5"
  }), React__default["default"].createElement("g", {
    transform: "translate(10.000000, 8.685791)"
  }, React__default["default"].createElement("g", {
    transform: "translate(57.103281, 0.000000)",
    fill: "#00C853",
    stroke: "#000000",
    strokeOpacity: "0.87",
    strokeWidth: "3"
  }, React__default["default"].createElement("polygon", {
    transform: "translate(60.000000, 59.000000) rotate(-44.000000) translate(-60.000000, -59.000000) ",
    points: "7.91570294 35 24.9406842 36.3456068 21.4596796 64.6443216 119 64.6443216 119 82.7730261 1 83"
  })), React__default["default"].createElement("g", {
    transform: "translate(8.000000, 98.314209)"
  }, React__default["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "64",
    height: "11"
  }), React__default["default"].createElement("rect", {
    fillOpacity: "0.87",
    fill: "#000000",
    x: "10",
    y: "4",
    width: "52",
    height: "3"
  }), React__default["default"].createElement("rect", {
    fillOpacity: "0.87",
    fill: "#000000",
    x: "2",
    y: "4",
    width: "4",
    height: "3"
  })), React__default["default"].createElement("g", {
    transform: "translate(0.000000, 76.314209)"
  }, React__default["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "58",
    height: "11"
  }), React__default["default"].createElement("rect", {
    fillOpacity: "0.87",
    fill: "#000000",
    x: "14",
    y: "4",
    width: "42",
    height: "3"
  }), React__default["default"].createElement("rect", {
    fillOpacity: "0.87",
    fill: "#000000",
    x: "2",
    y: "4",
    width: "8",
    height: "3"
  })), React__default["default"].createElement("g", {
    transform: "translate(12.000000, 55.314209)"
  }, React__default["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "45",
    height: "11"
  }), React__default["default"].createElement("rect", {
    fillOpacity: "0.87",
    fill: "#000000",
    x: "10",
    y: "4",
    width: "33",
    height: "3"
  }), React__default["default"].createElement("rect", {
    fillOpacity: "0.87",
    fill: "#000000",
    x: "2",
    y: "4",
    width: "4",
    height: "3"
  }))))));
};

module.exports = SuccessAlert;
